var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.429412 17.8388L20.5402 9.25059C20.8265 9.10745 20.8265 8.74961 20.5402 8.67804L0.429412 0.0182381C0.214706 -0.0533305 0 0.0898068 0 0.376081L0.429412 6.81726C0.50098 6.9604 0.572549 7.10353 0.715686 7.10353L9.01765 8.67804C9.30392 8.74961 9.30392 9.17902 9.01765 9.25059L0.715686 10.7535C0.572549 10.8251 0.50098 10.8967 0.50098 11.0398L0 17.5526C0 17.7673 0.214706 17.9104 0.429412 17.8388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.4f4661343af6963ee1abd1f5abb8f0ad.svg";
export { ForwardRef as ReactComponent };